let controller1 = new ScrollMagic.Controller();

//secton2 
var box2_img=document.getElementsByClassName('box2_img');
let scene2 = new ScrollMagic.Scene({
        offset: -200,
        triggerElement: '.box2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    box2_img[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_img[0].classList.remove("showup");
    }
})

//secton3
var box3_pro=document.getElementsByClassName('box3_pro');
let scene3 = new ScrollMagic.Scene({
        offset: -50,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3.on("progress", function (event) {
    box3_pro[0].classList.add("showup");
    if(window.innerWidth>750){
        $('.box3_pro').css({fontSize:'calc(78*16/1920*100vw)',top:'-21%',left:'-23%'})
    }else{
        $('.box3_pro').css({fontSize:'10rem',top:'12%',left:'2%'})
    }
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box3_pro[0].classList.remove("showup");
    }
})

let scene3__1 = new ScrollMagic.Scene({
        offset: 250,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3__1.on("progress", function (event) {
    if(window.innerWidth>750){
        $('.box3_pro').css({fontSize:'54rem',top:'-1%',left:'-7%'})
    }else{
        $('.box3_pro').css({fontSize:'7rem',top:'27%',left:'7%'})
    }
})

let scene3__2 = new ScrollMagic.Scene({
    offset: 300,
    triggerElement: '.box3', 
    triggerHook: "onenter",
    duration:0,
})
scene3__2.on("progress", function (event) {
    if(window.innerWidth>750){
        $('.box3_pro').css({fontSize:'42rem',top:'10%',left:'1%'})
    }else{
        $('.box3_pro').css({fontSize:'8rem',top:'22%',left:'6%'})
    }
})

let scene3__3 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box3', 
    triggerHook: "onenter",
    duration:0,
})
scene3__3.on("progress", function (event) {
    if(window.innerWidth>750){
        $('.box3_pro').css({fontSize:'66rem',top:'-12%',left:'-15%'})
    }else{
        $('.box3_pro').css({fontSize:'9rem',top:'17%',left:'4%'})
    }
})

var box3_title=document.getElementsByClassName('box3_title');
var box3_text=document.getElementsByClassName('box3_text');
let scene3_1 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box3',
    triggerHook: "0",
    duration:1000,
})
scene3_1.setPin('.box3');
scene3_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(window.innerWidth>750){
        if(index1>20){
            $('.box3_pro').css({fontSize:'30rem',top:'21%',left:'9%'})
        }
        if(index1>40){
            $('.box3_pro').css({fontSize:'18rem',top:'32%',left:'22%'})
        }
        if(index1>60){
            $('.box3_pro').css({fontSize:'calc(5.5*16/1920*100vw)',top:'45%',left:'32%'})
            $('.box3_mask').css({background:'rgba(0,0,0,0.5)'})
            box3_title[0].classList.add("showup");
        }
    }else{
        if(index1>20){
            $('.box3_pro').css({fontSize:'5rem',top:'32%',left:'8%'})
        }
        if(index1>40){
            $('.box3_pro').css({fontSize:'3rem',top:'37%',left:'9%'})
        }
        if(index1>60){
            $('.box3_pro').css({fontSize:'2rem',top:'42.5%',left:'10%'})
            $('.box3_mask').css({background:'rgba(0,0,0,0.5)'})
            box3_title[0].classList.add("showup");
        }
    }
    if(index1>90){
        box3_text[0].classList.add("showup");
    }
    if(index1<90){
        box3_text[0].classList.remove("showup");
    }
    if(index1<60){
        $('.box3_mask').css({background:'rgba(0,0,0,0)'})
        box3_title[0].classList.remove("showup");
    }

})


//secton5
var box5_title=document.getElementsByClassName('box5_title');
let scene5 = new ScrollMagic.Scene({
        offset: -30,
        triggerElement: '.box5', 
        triggerHook: "onenter",
        duration:0,
})
scene5.on("progress", function (event) {
    box5_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[0].classList.remove("showup");
    }
})

let scene5__1 = new ScrollMagic.Scene({
        offset: 150,
        triggerElement: '.box5', 
        triggerHook: "onenter",
        duration:0,
})
scene5__1.on("progress", function () {
    $('.box5_img').css({opacity:0})
    $('.box5_img1').css({opacity:1})
})

let scene5__2 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box5', 
    triggerHook: "onenter",
    duration:0,
})
scene5__2.on("progress", function () {
$('.box5_img').css({opacity:0})
$('.box5_img2').css({opacity:2})
})

let scene5__3 = new ScrollMagic.Scene({
    offset: 250,
    triggerElement: '.box5', 
    triggerHook: "onenter",
    duration:0,
})
scene5__3.on("progress", function () {
$('.box5_img').css({opacity:0})
$('.box5_img3').css({opacity:3})
})

let scene5__4 = new ScrollMagic.Scene({
    offset: 300,
    triggerElement: '.box5', 
    triggerHook: "onenter",
    duration:0,
})
scene5__4.on("progress", function () {
$('.box5_img').css({opacity:0})
$('.box5_img4').css({opacity:4})
})

let scene5_1 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box5',
    triggerHook: "0",
    duration:1000,
})
scene5_1.setPin('.box5');
scene5_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>10){
        $('.box5_img').css({opacity:0})
        $('.box5_img5').css({opacity:1})
    }
    if(index1>20){
        $('.box5_img').css({opacity:0})
        $('.box5_img6').css({opacity:1})
    }
    if(index1>30){
        $('.box5_img').css({opacity:0})
        $('.box5_img7').css({opacity:1})
    }
    if(index1>40){
        $('.box5_img').css({opacity:0})
        $('.box5_img8').css({opacity:1})
    }
    if(index1>50){
        $('.box5_img').css({opacity:0})
        $('.box5_img9').css({opacity:1})
    }
    if(index1>60){
        $('.box5_img').css({opacity:0})
        $('.box5_img10').css({opacity:1})
    }
    if(index1>70){
        $('.box5_img').css({opacity:0})
        $('.box5_img11').css({opacity:1})
    }
    if(index1>80){
        $('.box5_img').css({opacity:0})
        $('.box5_img12').css({opacity:1})
    }
    if(index1>90){
        $('.box5_img').css({opacity:0})
        $('.box5_img13').css({opacity:1})
    }

})

//secton6
let scene6__5 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box6', 
    triggerHook: "onenter",
    duration:0,
})
scene6__5.on("progress", function () {
$('.box6_screen').css({opacity:'0'})
$('.box6_screen1').css({opacity:'1'})
})
let scene6__1 = new ScrollMagic.Scene({
        offset: 250,
        triggerElement: '.box6', 
        triggerHook: "onenter",
        duration:0,
})
scene6__1.on("progress", function () {
    $('.box6_screen').css({opacity:'0'})
    $('.box6_screen2').css({opacity:'1'})
})
let scene6__2 = new ScrollMagic.Scene({
        offset: 300,
        triggerElement: '.box6', 
        triggerHook: "onenter",
        duration:0,
})
scene6__2.on("progress", function () {
    $('.box6_screen').css({opacity:'0'})
    $('.box6_screen3').css({opacity:'1'})
})

var box6_title=document.getElementsByClassName('box6_title');
let scene6 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box6',
    triggerHook: "0",
    duration:2000,
})
scene6.setPin('.box6');
scene6.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>10){
        $('.box6_screen').css({opacity:'0'})
        $('.box6_screen4').css({opacity:'1'})
    }
    if(index1>20){
        $('.box6_screen').css({opacity:'0'})
        $('.box6_screen5').css({opacity:'1'})
        $('.box6_screen7').css({opacity:'0'})
    }
    if(index1>30){
        $('.box6_screen').css({opacity:'0'})
        $('.box6_screen6').css({opacity:'1'})
        $('.box6_screen7').css({opacity:'1'})
        $('.box6_theme').css({opacity:'0'})
    }
    if(index1>40){
        $('.box6_screen').css({opacity:'0'})
        if(window.innerWidth>750){
            $('.box6_screen7').css({opacity:'1',width:'24%',left:'38%',top:'10%'})
        }else{
            $('.box6_screen7').css({opacity:'1',width:'68%',left:'16%',top:'18%'})
        }
        $('.box6_theme').css({opacity:'0'})
    }
    if(index1>50){
        $('.box6_screen').css({opacity:'0'})
        if(window.innerWidth>750){
            $('.box6_screen7').css({opacity:'1',width:'18%',left:'41%',top:'14%',transition:'all 1s'})
        }else{
            $('.box6_screen7').css({opacity:'1',width:'60%',left:'20%',top:'26%',transition:'all 1s'})
        }
        $('.box6_theme').css({opacity:'0.4',transform:'scale(1.8)'})
    }
    if(index1>60){
        $('.box6_screen7').css({opacity:'0'})
        $('.box6_border').css({opacity:'1'})
        $('.box6_gif').css({opacity:'1'})
        $('.box6_theme').css({opacity:'0.7',transform:'scale(1.4)'})
    }
    if(index1>70){
        $('.box6_theme').css({opacity:'1',transform:'scale(1)'})
        box6_title[0].classList.remove("showup");
    }
    if(index1>80){
        box6_title[0].classList.add("showup");
    }
    if(index1<60){
        $('.box6_border').css({opacity:'0'})
        $('.box6_gif').css({opacity:'0'})
    }

})



var box7_title=document.getElementsByClassName('box7_title');
let scene7_1 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box7', 
        triggerHook: "onenter",
        duration:0,
})
scene7_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box7_title[0].classList.add("showup");
    if(index1<2){
        box7_title[0].classList.remove("showup");
    }

})

let scene7_2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Mbox7', 
        triggerHook: "onenter",
        duration:0,
})
scene7_2.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box7_title[1].classList.add("showup");
    if(index1<2){
        box7_title[1].classList.remove("showup");
    }

})

let scene7 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box7',
    triggerHook: "0",
    duration:1000,
})
scene7.setPin('.box7');
scene7.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(window.innerWidth>750){
        if(index1<50){
            $('.box7_items').css({marginLeft:'18%'})
        }
        if(index1>50){
            $('.box7_items').css({marginLeft:'-51%'})
        }
    }

})

var box8_title=document.getElementsByClassName('box8_title');
let scene8_3 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box8', 
        triggerHook: "onenter",
        duration:0,
})
scene8_3.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box8_title[0].classList.add("showup");
    if(index1<2){
        box8_title[0].classList.remove("showup");
        $('.box8_img1').css({opacity:'1'})
    }

})

let scene8 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    $('.box8_img1').css({opacity:'0.8'})

})
let scene8_1 = new ScrollMagic.Scene({
    offset: 250,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    $('.box8_img1').css({opacity:'0.6'})

})
let scene8_2 = new ScrollMagic.Scene({
    offset: 350,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8_2.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    $('.box8_img1').css({opacity:'0.4'})

})

var box8_info=document.getElementsByClassName('box8_info');
var box8_text=document.getElementsByClassName('box8_text');
let scene8_4 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box8',
    triggerHook: "0",
    duration:1000,
})
scene8_4.setPin('.box8');
scene8_4.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>20){
        $('.box8_img1').css({opacity:'0.3'})
    }
    if(index1>40){
        $('.box8_img1').css({opacity:'0.1'})
    }
    if(index1>60){
        $('.box8_img1').css({opacity:'0'})
        box8_info[0].classList.remove("showup");
        box8_text[0].classList.remove("showup");
    }
    if(index1>80){
        box8_info[0].classList.add("showup");
        box8_text[0].classList.add("showup");
    }
    

})

var box9_title=document.getElementsByClassName('box9_title');
let scene9 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box9',
    triggerHook: "onenter",
    duration:0,
})
scene9.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box9_title[0].classList.add("showup");
    if(index1<2){
        box9_title[0].classList.remove("showup");
    }
    

})

var box11_title=document.getElementsByClassName('box11_title');
let scene11 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box11_title[0].classList.add("showup");
    if(index1<2){
        box11_title[0].classList.remove("showup");
    }
    

})

var box11_title=document.getElementsByClassName('box11_title');
let scene11_1 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11_1.on("progress", function () {
    $('.box11_img').hide()
    $('.box11_img2').show()

})
var box11_title=document.getElementsByClassName('box11_title');
let scene11_2 = new ScrollMagic.Scene({
    offset: 250,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11_2.on("progress", function () {
    $('.box11_img').hide()
    $('.box11_img3').show()
})
var box11_title=document.getElementsByClassName('box11_title');
let scene11_3 = new ScrollMagic.Scene({
    offset: 300,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11_3.on("progress", function () {
    $('.box11_img').hide()
    $('.box11_img4').show()
})
var box11_title=document.getElementsByClassName('box11_title');
let scene11_4 = new ScrollMagic.Scene({
    offset: 350,
    triggerElement: '.box11',
    triggerHook: "onenter",
    duration:0,
})
scene11_4.on("progress", function () {
    $('.box11_img').hide()
    $('.box11_img5').show()
})

let scene11_5 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box11',
    triggerHook: "0",
    duration:1000,
})
scene11_5.setPin('.box11');
scene11_5.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>10){
        $('.box11_img').hide()
        $('.box11_img6').show()
    }
    if(index1>20){
        $('.box11_img').hide()
        $('.box11_img7').show()
    }
    if(index1>30){
        $('.box11_img').hide()
        $('.box11_img8').show()
    }
    if(index1>40){
        $('.box11_img').hide()
        $('.box11_img9').show()
    }
    if(index1>50){
        $('.box11_img').hide()
        $('.box11_img10').show()
    }
    if(index1>60){
        $('.box11_img').hide()
        $('.box11_img11').show()
    }
    if(index1>70){
        $('.box11_img').hide()
        $('.box11_img12').show()
    }
    if(index1>80){
        $('.box11_img').hide()
        $('.box11_img13').show()
    }
    if(index1>90){
        $('.box11_img').hide()
        $('.box11_img13').show()
        $('.box11_img14').show()
    }
    

})


let scene12 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box12',
    triggerHook: "onenter",
    duration:0,
})
scene12.on("progress", function () {
    $('.box12_img').css({transform:'scale(1.3)'})

})
let scene12_1 = new ScrollMagic.Scene({
    offset: 100,
    triggerElement: '.box12',
    triggerHook: "onenter",
    duration:0,
})
scene12_1.on("progress", function () {
    $('.box12_img').css({transform:'scale(1.2)'})

})
let scene12_2 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box12',
    triggerHook: "onenter",
    duration:0,
})
scene12_2.on("progress", function () {
    $('.box12_img').css({transform:'scale(1)'})

})


var box13_title=document.getElementsByClassName('box13_title');
let scene13 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box13',
    triggerHook: "onenter",
    duration:0,
})
scene13.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box13_title[0].classList.add("showup");
    if(index1<2){
        box13_title[0].classList.remove("showup");
    }
})

var box14_title=document.getElementsByClassName('box14_title');
let scene14 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box14',
    triggerHook: "onenter",
    duration:0,
})
scene14.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box14_title[0].classList.add("showup");
    if(index1<2){
        box14_title[0].classList.remove("showup");
    }
})

var box10_title=document.getElementsByClassName('box10_title');
let scene10 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box10',
    triggerHook: "onenter",
    duration:0,
})
scene10.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box10_title[0].classList.add("showup");
    if(index1<2){
        box10_title[0].classList.remove("showup");
    }
})



controller1.addScene([scene2,scene3,scene3__1,scene3__2,scene3_1,scene3__3,scene5,scene5_1,scene5__1,scene5__2,scene5__3,scene5__4,scene6,
    scene6__1,scene6__2,scene6__5,scene7,scene7_1,scene7_2,scene8_1,scene8_2,scene8_3,scene8_4,scene9,scene11,scene11_1,scene11_2,scene11_3,
    scene11_4,scene11_5,scene12,scene12_1,scene12_2,scene13,scene14,scene10
]); 

var box10Swiper = new Swiper('.box10Swiper', {
	on:{
        slideChange: function(){
            $('.box10_btns').css({"background":"rgba(0,0,0,0)",color:'white'})
          if(this.activeIndex == 0){
            $('.box10_mask').css({'left':'0','opacity':'1'})
            $('.box10_btns:nth-child(2)').css({color:'black'})
          }else if(this.activeIndex == 1){
            $('.box10_mask').css({'left':'33.3%','opacity':'1'})
            $('.box10_btns:nth-child(3)').css({color:'black'})
          }else if(this.activeIndex == 2){
            $('.box10_mask').css({'left':'66.6%','opacity':'1'})
            $('.box10_btns:nth-child(4)').css({color:'black'})
          }
        },
      },
})


$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/collections/best-selling-products/products/oxva-xlim-sq-pro-kit'); 
})


$('.box10_btns').hover(function(){
    $('.box10_btns').css({"background":"rgba(0,0,0,0)",color:'white'})
    $(this).css({color:'black'})
    var index = $(this).index();
    var position = $(this).position();
    if(index == 1){
        box10Swiper.slideTo(0, 0, false);
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }else if(index ==2){
        box10Swiper.slideTo(1, 0, false);
        box10Swiper.update()
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }else if(index ==3){
        box10Swiper.slideTo(2, 0, false);
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }
})

$('.box7_play').click(function(){
    $('.box7_popup').css({opacity:'1',zIndex:'8'})
    if(window.innerWidth>750){
        $('.box7_popup video')[0].play()
    }else{
        $('.box7_popup video')[1].play()
    }
})

$('.box7_popup img').click(function(){
    $('.box7_popup').css({opacity:'0',zIndex:'-1'})
})

var active = 1;
var flag = true;
$('.box4_icon2').click(function(){
    if(active < 12 && flag){
        flag = false
        var dom = $(`.box4_${active}`)

        for(var i =1;i<13;i++){
            if(i != active+1 && i != active){
                $(`.box4_${i}`).css({zIndex:'1',opacity:'0'})
            }
            if(i != active+1){
                $(`.box4_btn${i}`).parent().css({border:'1px solid white'})
            }else{
                $(`.box4_btn${i}`).parent().css({border:'1px solid #999'})
            }
        }
        dom.css({zIndex:'3',opacity:'1'})
        $(`.box4_${active+1}`).css({zIndex:'2',opacity:'1',width:'100%',transition:'none'})

        let num1 = 100;
        let num2 = 20;

        const box1 = setInterval(() => {
        if (num1 > 80) {
            num1--;
            dom.css({width:`${num1}%`,transition:'all 1s'})
            num2--;
            dom.children('.box4_bgw').css({width:`${num2}%`,transition:'all 1s'})
        } else if(num1 <= 80&& num1>=0){
            num1--;
            dom.css({width:`${num1}%`,transition:'all 1s'})
            if(num1 == -1){
                flag = true;
            }
        } else {
            clearInterval(box1);
        }
        }, 1);
        active++;
    }
    
})


$('.box4_icon1').click(function(){
    if(active > 1 && flag){
        flag = false
        var dom = $(`.box4_${active-1}`)

        for(var i =1;i<13;i++){
            if(i != active-1 && i != active){
                $(`.box4_${i}`).css({zIndex:'1',opacity:'0'})
            }
            if(i != active-1){
                $(`.box4_btn${i}`).parent().css({border:'1px solid white'})
            }else{
                $(`.box4_btn${i}`).parent().css({border:'1px solid #999'})
            }
        }
        $(`.box4_${active}`).css({zIndex:'2',opacity:'1'})
        dom.css({zIndex:'3',opacity:'1'})

        let num11 = 0;

        const box2 = setInterval(() => {
        if (num11 < 80) {
            num11++;
            dom.css({width:`${num11}%`})
            dom.children('.box4_bgw').css({width:'0%'})
        } else if(num11 > 79 && num11 < 100){
            num11++;
            dom.css({width:`${num11}%`})
            dom.children('.box4_bg').css({width:'calc(57*16/1920*100vw)'})
            if(num11 == 100){
                flag = true
            }
        } else {
            clearInterval(box2);
        }
        }, 1);
        active--
    }
})

var activeFlag = true //不能连续点击
$('.box4_border').click(function(){
    $('.box4_border').css({border:'1px solid white'})
    $(this).css({border:'1px solid #999'})
    var index = $(this).parent().index()+1
    if(index != active && activeFlag){
        activeFlag = false;
        var dom = $(`.box4_${active}`)

        for(var i =1;i<13;i++){
            if(i != index && i != active){
                $(`.box4_${i}`).css({zIndex:'1',opacity:'0',width:'0%'})
            }
        }
        dom.css({width:'100%',zIndex:'3',opacity:'1',transition:'none'})
        $(`.box4_${index}`).css({width:'100%',zIndex:'2',opacity:'1',transition:'none'})

        let num1 = 100;
        let num2 = 20;

        const box1 = setInterval(() => {
        if (num1 > 80) {
            num1--;
            dom.css({width:`${num1}%`,transition:'all 1s'})
            num2--;
            dom.children('.box4_bgw').css({width:`${num2}%`,transition:'all 1s'})
        } else if(num1 <= 80&& num1>=0){
            num1--;
            dom.css({width:`${num1}%`,transition:'all 1s'})
            if(num1 == -1){
                activeFlag = true;
            }
        } else {
            clearInterval(box1);
        }
        }, 1);
        active = index
    }
})

var Mbox4Swiper = new Swiper('.Mbox4Swiper', {
    effect: 'fade',
    pagination: {
        el: '.r8s6img',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color='#69827c';break;
            case 1:color='#a4836c';break;
            case 2:color='#1a356b';break;
            case 3:color='#272727';break;
            case 4:color='#181818';break;
            case 5:color='#e2d39c';break;
            case 6:color='#3e332f';break;
            case 7:color='#3a3b40';break;
            case 8:color='#a7b288';break;
            case 9:color='#c4c2d7';break;
            case 10:color='linear-gradient(to bottom,#e4c0c6,#c4e6f5)';break;
            case 11:color='#25354e';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})



$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})